const SETTINGS_SECTION_SCHEMAS = [
  {
    id: 'issue-management',
    order: 10,
    title: 'Issue Management',
    iconName: 'Bug',
    kind: 'issue-management',
    keywords: ['issue management', 'issue tracker', 'bugzilla', 'jira'],
  },
  {
    id: 'version-control',
    order: 20,
    title: 'Version Control',
    iconName: 'GitBranch',
    kind: 'version-control-wizard',
    keywords: ['version control', 'source control', 'git', 'repository'],
  },
  {
    id: 'rollout-package',
    order: 30,
    title: 'Rollout Package',
    iconName: 'Package',
    kind: 'rollout-package-split',
    keywords: ['rollout package', 'package', 'artifact', 'bundle'],
  },
  {
    id: 'system',
    order: 40,
    title: 'System',
    iconName: 'Settings2',
    kind: 'generic-flat',
    keywords: ['system', 'environment', 'runtime'],
  },
  {
    id: 'database',
    order: 50,
    title: 'Database Configuration',
    iconName: 'Database',
    kind: 'generic-provider-flow',
    keywords: ['database', 'db', 'oracle', 'sql'],
  },
  {
    id: 'authentication',
    order: 60,
    title: 'Authentication',
    iconName: 'ShieldCheck',
    kind: 'auth-subsections',
    keywords: ['auth', 'authentication', 'login provider', 'sso'],
  },
  {
    id: 'yaml',
    order: 70,
    title: 'YAML',
    iconName: 'Files',
    kind: 'generic-flat',
    keywords: ['yaml', 'refs', 'reference'],
  },
  {
    id: 'webhook',
    order: 80,
    title: 'Webhook',
    iconName: 'Send',
    kind: 'generic-flat',
    keywords: ['webhook', 'hook'],
  },
];

const getNormalizedSectionText = (sectionKey = '', section = {}) =>
  `${sectionKey} ${section?.Properties?.Name || ''}`.toLowerCase();

export const resolveSectionUiSchema = (sectionKey, section) => {
  const normalizedText = getNormalizedSectionText(sectionKey, section);
  const matchedSchema = SETTINGS_SECTION_SCHEMAS.find(({ keywords = [] }) =>
    keywords.some((keyword) => normalizedText.includes(keyword))
  );

  if (matchedSchema) {
    return matchedSchema;
  }

  return {
    id: sectionKey,
    order: 999,
    title: section?.Properties?.Name || sectionKey,
    iconName: section?.Properties?.Icon || '',
    kind: section?.Properties?.subsection ? 'auth-subsections' : 'generic-provider-flow',
  };
};

export const sortSectionEntries = (entries = []) =>
  [...entries].sort((left, right) => {
    if (left.order !== right.order) {
      return left.order - right.order;
    }

    return left.index - right.index;
  });
